// extracted by mini-css-extract-plugin
export default {"root":"InviteUser_root__nYvHY","addMore":"InviteUser_addMore__IWdRd"};